export default __webpack_public_path__ + "static/media/test-tube-right.218b7cc4.gif";